<template>
    <div class="form-box">
        <div class="form-left">
            <p v-for="(item,index) in dataTree" :key="index" :class="(curId==index?'on':'')" @click="handleNodeClick(item,index)" style="width:100%;height:4vh;position: relative;display: flex;align-content: center;align-items: center;padding-left: 1vh;cursor: pointer;">
                {{item.name}}
            </p>
        </div>
        <div class="form-right">
            <div style="width:100%;height:5vh;padding-left:1vw;background:#fff;display:flex;align-items: center;">
                <el-page-header @back="goBack" content="项目审定产值明细表"></el-page-header>
            </div>
            <div style="width:100%;height:calc( 100% - 5vh );position: relative;padding:1vh;background:#fff;">
                <el-table :data="tableData" border style="width: 100%" height="100%" :header-row-class-name="'table-head'">
                    <template slot="empty">
                        <p>{{dataText}}</p>
                    </template>
                    <el-table-column prop="index" label="序号" width="200">
                        <template slot-scope="scope">
                            <span>{{scope.row.index}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="time" label="日期">
                        <template slot-scope="scope">
                            <span>{{scope.row.time}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="apprMoney" label="审定产值（万元）">
                        <template slot-scope="scope">
                            <span>{{scope.row.apprMoney}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="cumulativePay" label="累计审定产值（万元）">
                        <template slot-scope="scope">
                            <span>{{scope.row.cumulativePay}}</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="success" @click="infoFun(scope.row)">查看</el-button>
                        </template>
                    </el-table-column> -->
                </el-table>

            </div>
        </div>
    </div>
</template>

<script>
import myHttp from '../../../untils/port'
import util from '../../../untils/util'
export default {
    data(){
        return{
            groupId:'',
            dataTree:[],
            defaultProps: {
                children: 'list',
                label: 'name'
            },
            projectId:'',//当前项目id
            currentNodekey:'',//当前树形选中值
            expandedkeys:[],//树形展开值
            dataText: '数据加载中...',
            tableData:[],
            curId:0,
        }
    },
    mounted(){
        this.groupId = util.session.get('groupId')
        this.getLeftMenu()
    },
    methods:{
        //获取侧边树
        getLeftMenu(){
            var that = this
            myHttp.getEntProjectList({
                groupId: this.groupId,
                pageNum:1,
                pageSize:10000
            }).then(function(resp) {
                if (resp.data.code == '200') {
                    var list = resp.data.data.entProject.list || []
                    that.dataTree = list
                    if (list.length > 0 && that.projectId=='') {
                        that.projectId= list[0].id
                        that.getData()
                    }
                }
            })
        },
        //树形点击
        handleNodeClick(e,index){
            this.projectId = e.id
            this.curId = index
            this.getData()
        },
        //获取数据
        getData(){
            // if(!this.projectId||this.projectId==''){
            //     this.tableData = []
            //     this.dataText = '暂无数据'
            //     return
            // }
            var that = this
            this.tableData = []
            myHttp.selectPayByEntProjectId({
                entId:this.groupId,
                entProjectId:this.projectId
            }).then(function(resp){
                console.log(resp)
                if(resp.data.code=='200'){
                    var data = resp.data.data.entity
                    if(data){
                        var list = JSON.parse(data.first).list||[]
                        for(var i=0;i<list.length;i++){
                            list[i].index = i+1
                            if(i==0){
                                list[i].cumulativePay = list[i].apprMoney
                            }else{
                                list[i].cumulativePay = parseFloat(list[i-1].cumulativePay)+parseFloat(list[i].apprMoney)
                            }
                        }
                        that.tableData = list
                    }else{
                        that.dataText = '暂无数据'
                    }
                }else{
                    that.dataText = '暂无数据'
                }
            })
        },

        //返回
        goBack(){
            this.$router.go(-1)
        },
    }
}
</script>

<style scoped>
    .form-box{
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        padding: 1vh;
    }
    .form-left{
        width:15vw;
        height: 100%;
        position: relative;
        background: #fff;
        padding: 1vh;
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        align-items: flex-start;
    }
    .form-left .on{
        color: #2447D7;
    }
    .form-right{
        width: calc( 100% - 15vw );
        height: 100%;
        position: relative;
        padding-left: 1vh;
    }
</style>

<style>

</style>